import { getISOString } from 'owa-datetime';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from 'owa-viewstate-store';
import { createStore } from 'owa-satcheljs';
import { mutatorAction } from 'satcheljs';

import type { DateRange } from 'owa-datetime-utils';
import type { Collaborator } from 'hybridspace-common/lib/serviceTypes';
import type { WorkLocationSurfaceType } from 'owa-calendar-working-hours-location-utils';
import type { Location } from 'owa-graph-schema';

const getStore = createStore('places-people-schedule-store', {
    collaboratorScheduleLocations: new Map<
        string,
        Map<
            number,
            {
                workLocationSurfaceType: WorkLocationSurfaceType | 'Error';
                buildingId?: Location['id'];
            }
        >
    >(),
    collaboratorsOfficeLocations: new Map<number, Map<string, string[]>>(),
    savedCollaborators: [] as Collaborator[],
    suggestedCollaborators: [] as Collaborator[],
    serviceCallsCompleted: [] as string[],
});

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const setCollaboratorLocationsServiceCallComplete: (dateRange: DateRange) => void =
    mutatorAction('setCollaboratorLocationsServiceCallComplete', (dateRange: DateRange): void => {
        const key = getISOString(dateRange.start) + '--' + getISOString(dateRange.end);
        if (getStore().serviceCallsCompleted.indexOf(key) === -1) {
            getStore().serviceCallsCompleted.push(key);
        }
    });

const dest = createAccessors('places-people-schedule-store', getStore);
export const getCollaboratorsOfficeLocations: () => Map<number, Map<string, string[]>> =
    dest.getCollaboratorsOfficeLocations;
export const setCollaboratorsOfficeLocations: (
    newValue: Map<number, Map<string, string[]>>
) => void = dest.setCollaboratorsOfficeLocations;
export const getCollaboratorScheduleLocations: () => Map<
    string,
    Map<
        number,
        {
            workLocationSurfaceType: WorkLocationSurfaceType | 'Error';
            buildingId?: Location['id'];
        }
    >
> = dest.getCollaboratorScheduleLocations;
export const setCollaboratorScheduleLocations: (
    newValue: Map<
        string,
        Map<
            number,
            {
                workLocationSurfaceType: WorkLocationSurfaceType | 'Error';
                buildingId?: Location['id'];
            }
        >
    >
) => void = dest.setCollaboratorScheduleLocations;
export const getSavedCollaborators: () => Collaborator[] = dest.getSavedCollaborators;
export const setSavedCollaborators: (newValue: Collaborator[]) => void = dest.setSavedCollaborators;
export const getSuggestedCollaborators: () => Collaborator[] = dest.getSuggestedCollaborators;
export const setSuggestedCollaborators: (newValue: Collaborator[]) => void =
    dest.setSuggestedCollaborators;
export const getServiceCallsCompleted: () => string[] = dest.getServiceCallsCompleted;
